import React, { useState } from 'react';
import { FaFolder, FaPlus, FaTrash, FaChevronDown, FaChevronRight, FaGripVertical } from 'react-icons/fa';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import SubmoduleBuilder from './SubmoduleBuilder.jsx';
import LessonBuilder from './LessonBuilder.jsx';
import './ModuleBuilder.css';

const ModuleBuilder = ({ module, onUpdate, onDelete, index }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const handleTitleChange = (e) => {
    onUpdate({ ...module, title: e.target.value });
  };

  const handleAddSubmodule = () => {
    const newSubmodule = {
      id: `submodule-${Date.now()}-${Math.random()}`,
      title: '',
      lessons: [],
      order: module.submodules ? module.submodules.length : 0
    };

    onUpdate({
      ...module,
      submodules: [...(module.submodules || []), newSubmodule]
    });
  };

  const handleAddLesson = () => {
    const newLesson = {
      id: `lesson-${Date.now()}-${Math.random()}`,
      title: '',
      duration: 0,
      videoUrl: '',
      type: 'video', // Required by Mongoose Schema
      order: module.lessons ? module.lessons.length : 0
    };

    onUpdate({
      ...module,
      lessons: [...(module.lessons || []), newLesson]
    });
  };

  const handleUpdateSubmodule = (submoduleId, updatedSubmodule) => {
    const updatedSubmodules = module.submodules.map(sub =>
      sub.id === submoduleId ? updatedSubmodule : sub
    );
    onUpdate({ ...module, submodules: updatedSubmodules });
  };

  const handleDeleteSubmodule = (submoduleId) => {
    const updatedSubmodules = module.submodules.filter(sub => sub.id !== submoduleId);
    onUpdate({ ...module, submodules: updatedSubmodules });
  };

  const handleUpdateLesson = (lessonId, updatedLesson) => {
    const updatedLessons = module.lessons.map(lesson =>
      lesson.id === lessonId ? updatedLesson : lesson
    );
    onUpdate({ ...module, lessons: updatedLessons });
  };

  const handleDeleteLesson = (lessonId) => {
    const updatedLessons = module.lessons.filter(lesson => lesson.id !== lessonId);
    onUpdate({ ...module, lessons: updatedLessons });
  };

  return (
    <div className="module-item">
      <div className="module-header">
        <div className="module-header-left">
          <FaGripVertical className="drag-handle" />
          <button
            type="button"
            className="expand-toggle"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded ? <FaChevronDown /> : <FaChevronRight />}
          </button>
          <FaFolder className="module-icon" />
          <input
            type="text"
            value={module.title || ''}
            onChange={handleTitleChange}
            placeholder="Module title"
            className="module-title-input"
            required
          />
        </div>
        <div className="module-header-right">
          <button
            type="button"
            className="btn btn-sm btn-outline"
            onClick={handleAddSubmodule}
          >
            <FaPlus /> Add Submodule
          </button>
          <button
            type="button"
            className="btn btn-sm btn-outline"
            onClick={handleAddLesson}
          >
            <FaPlus /> Add Lesson
          </button>
          <button
            type="button"
            className="btn-icon btn-delete"
            onClick={onDelete}
            title="Delete Module"
          >
            <FaTrash />
          </button>
        </div>
      </div>

      {isExpanded && (
        <div className="module-content">
          {/* Submodules */}
          {module.submodules && module.submodules.length > 0 && (
            <div className="submodules-list">
              <h4 className="section-title">Submodules</h4>
              {module.submodules.map((submodule, subIndex) => (
                <SubmoduleBuilder
                  key={submodule.id}
                  submodule={submodule}
                  moduleIndex={index}
                  submoduleIndex={subIndex}
                  onUpdate={(updatedSubmodule) => handleUpdateSubmodule(submodule.id, updatedSubmodule)}
                  onDelete={() => handleDeleteSubmodule(submodule.id)}
                />
              ))}
            </div>
          )}

          {/* Direct Lessons */}
          {module.lessons && module.lessons.length > 0 && (
            <div className="lessons-list">
              <h4 className="section-title">Lessons</h4>
              {module.lessons.map((lesson, lessonIndex) => (
                <LessonBuilder
                  key={lesson.id}
                  lesson={lesson}
                  index={lessonIndex}
                  onUpdate={(updatedLesson) => handleUpdateLesson(lesson.id, updatedLesson)}
                  onDelete={() => handleDeleteLesson(lesson.id)}
                />
              ))}
            </div>
          )}

          {/* Empty State */}
          {(!module.submodules || module.submodules.length === 0) &&
            (!module.lessons || module.lessons.length === 0) && (
              <div className="empty-state">
                <p>No submodules or lessons yet. Add your first submodule or lesson to get started.</p>
              </div>
            )}
        </div>
      )}
    </div>
  );
};

export default ModuleBuilder;
